export default __webpack_public_path__ + "static/media/down.6e8b6514.svg";